/**
 * Class description
 *
 * Created: 2019-07-31
 * @author jonas
 */

import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Container, Sprite,Graphics} from "pixi.js";

import {StandardAutoCloseGameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/game/screen/StandardAutoCloseGameModeTransitionView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {CountDownTimer} from "@nolimitcity/slot-game/bin/core/component/CountDownTimer";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bonusWheelEvents} from "../gameround/bonusWheelController";
import {TweenLite,TimelineLite ,Linear} from "gsap";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {freezeLayers} from "../utils/freezeGame";
import {SoundManager} from "../resource/sound/SoundManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {bigWinEvents} from "../views/WinTextView";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
export class ImmortalFruitsbonusViewIntroView extends StandardAutoCloseGameModeTransitionView {
    private _compCallback: () => void;
    private _gameGraphics: Graphics;
    private _gameBackground: PIXI.Container;
    private introSpine :PIXI.spine.Spine;
    private xOffSet:number=0;
    private yOffSet:number=0;
    private isPortrait:boolean =false;
    private isPlayingBlur:boolean =false;

    constructor(layer: ScalableLayer, autoCloseTimerDuration: number = 20) {
        super(layer, autoCloseTimerDuration);
    }


    protected createBackground(): PIXI.DisplayObject {
        this._gameBackground = new PIXI.Container();
        this._gameBackground.name = "Background";
        this.introSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("intro"));
        this.introSpine.renderable =false;
        this._gameBackground.visible = true;
        return this._gameBackground;
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._autoCloseTimer = this.createAutoCloseTimer();
        this._autoCloseTimer.visible = false;
        this._gameGraphics = new Graphics();
        this._gameGraphics.clear();
        this._gameGraphics.beginFill(0x000000, 0.4);
        this._gameGraphics.pivot.set(0.5, 0.5);

        return this._gameGraphics;
    }

    private internalImmortalCompleteCallback() {
        if (this._compCallback) {
            this.stopTimerAndDisableButton();
            this._compCallback();
            this._gameBackground.visible = false;
            SlotGame.keypad.show();
            SoundManager.playContinueBtn();
        }
    }

    protected createButton(): NineSliceButton {
        const text: string = Translation.translate("CONTINUE");
        const textStyle: TextStyleOptions = this.getImmortalcaledButtonTextStyle();
        const button = new NineSliceButton(() => this.internalImmortalCompleteCallback(), ` ${text} `, textStyle);
        button.enabled = false;
        button.visible = false;
        return button;
    }

    private getImmortalcaledButtonTextStyle(): TextStyleOptions {
        const style: TextStyleOptions = this.BUTTON_TEXT_STYLE;
        if (typeof style.fontSize !== 'number') {
            debugger;
            throw new Error("Error: IntoView.getScaledButtonTextStyle(): please use number fontSize!");
        }
        style.fontSize = (<number>style.fontSize) * this._deviceScale;
        return style;
    }

    public startTimerAndEnableButton(callback: () => void) {

        this._gameBackground.addChild(this._gameGraphics);
        this._layer.addChild(this.introSpine);
        this._compCallback = callback;

        this._button.visible = true;
        this._gameBackground.scale.set(1, 1);
        this._gameGraphics.scale.set(1);
        this._gameBackground.y = NolimitApplication.screenBounds.height / 2 * 0.2;
        this._gameBackground.alpha = 0.7;
        this._button.alpha = 0;
        let tl = new TimelineLite({
            onComplete: () => {
                tl.clear();
                tl.kill()
            }
        });
        /*#132*/
        StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name).getChildByName("reelAreaCover").alpha=1;
        freezeLayers.addBlur(this._layer);
        this.isPlayingBlur =true;
        tl.add(() => {
            this.introSpine.renderable =true;
            EventHandler.dispatchEvent(new GameEvent(bigWinEvents.STOP_GREENLIGHTS ));
            new SpineTween(this.introSpine, 0, "intro_animation", 0);
            SoundManager.playBonusIntroLogo();
            TweenLite.delayedCall(0.250, SoundManager.playBonusBG);
            SoundManager.fadeOutMainBGSound(500);
            //SoundManager.playBonusBG();
            //250ms

        }, 0);
        tl.add(() => {
            if(this.isPortrait){
                this.introSpine.scale.set(0.8);
            }else{
                this.introSpine.scale.set(1);
            }
            this._gameGraphics.alpha = 0.4;
        }, 0.2);
        tl.add(() => {
        }, 2);
        tl.add(() => {
            this.introSpine.renderable =false;

            EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.SHOW_WHEEL_ANIMATION));
            this.isPlayingBlur =false;
            /* #132 fixed*/
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.REEL_BACKGROUND.name).getChildByName("reelAreaCover").alpha=0;
            freezeLayers.removeBlur(this._layer);
            this._gameGraphics.alpha = 0;
            this._gameBackground.visible = true;
            this._button.visible = true;
            TweenLite.to(this._gameBackground, 1, {alpha: 1});
        }, 2.4 );
        tl.add(() => {

            TweenLite.to(this._button, 0.2, {alpha: 1,onComplete:()=>{
                    this._button.enabled = true;
                }});
        }, 2+0.4+3*0.15+0.6);
    }

    public stopTimerAndDisableButton() {
        this._button.enabled = false;
        this._button.visible = false;
    }

    protected createAutoCloseTimer(): CountDownTimer {
        const tmr: CountDownTimer = super.createAutoCloseTimer();
        return tmr;
    }

    protected onResize(data: IResizeData): void {
        super.onResize(data);

        this.introSpine.pivot.set(0.5 , 0.5);
       if(this.isPlayingBlur){
           freezeLayers.onResize(this._layer)//#175 #178 fixed
       }
        if ("portrait" == data.orientation) {
            this.isPortrait =true;
            this.xOffSet =ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X;
            this.yOffSet =ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT * 2.5 -25;
            this.introSpine.scale.set(0.8);

        } else {
            this.isPortrait = false;
            this.introSpine.scale.set(1);
            this.xOffSet = ImmortalFruitsGameConfig.instance.REEL_AREA_CENTER_X;
            this.yOffSet = ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y + ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT * 2;
        }
        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
        this._gameGraphics.clear();
        this._gameGraphics.pivot.set(0.5, 0.5);
        this._gameGraphics.drawRect(-400, -400, NolimitApplication.screenBounds.width + 400, NolimitApplication.screenBounds.height + 400);
        this._gameGraphics.beginFill(0x000000, 0.4);
        this.introSpine.position.set(360 , this.yOffSet);
    }

    /**
     * @description To implement any animation for this view.
     * @param prepareToEnterModeCallback
     * @param completeCallback
     */
    public getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        const tl = new TimelineLite();// super.getStartAnimation(prepareToEnterModeCallback, completeCallback);

        this._layer.addChild(this);
        this._mainGraphicsContainer.alpha = 1;
        tl.add(() => {
            this.startTimerAndEnableButton(completeCallback);
            SlotGame.keypad.hide();
        }, 0.5);
        return tl;
    }
    public getEndAnimation () {
        const tl = new TimelineLite();
        tl.add([
            new TweenLite(this._mainGraphicsContainer, 0, { alpha: 0, ease: Linear.easeNone }),
            this._fullScreenFade.getFadeOut(0)
        ]);
        tl.add(()=>{
            // This will turn off Autoplay if in restricted jurisdiction
            if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
                SlotGame.autoPlay.turnOffAutoplayOnBonus();
            }
            this._layer.removeChild(this);
        });
        return tl;
    };
}